import { VehicleByCarline, VehicleByAudiCode, StockCarTypes } from '../types';

type getVehicleDataToSubmitTypes = {
  vehicle: StockCarTypes | undefined;
  vehicleByCarline: VehicleByCarline | undefined;
  vehicleByAudiCode: VehicleByAudiCode | undefined;
  isTier3: boolean;
};

export const getVehicleDataToSubmit = ({
  vehicle,
  vehicleByAudiCode,
  vehicleByCarline,
  isTier3,
}: getVehicleDataToSubmitTypes) => {
  if (vehicleByAudiCode) {
    return {
      make: 'Audi',
      model: vehicleByAudiCode.titleText,
      year: vehicleByAudiCode.model.salesModelyear,
      trim: vehicleByAudiCode.subtitleText,
      options: [{ manufacturerCode: vehicleByAudiCode.audiCode, name: 'audiCode' }],
    };
  }

  if (vehicleByCarline) {
    return {
      make: 'Audi',
      model: vehicleByCarline.titleText,
      year: vehicleByCarline.model.salesModelyear,
    };
  }

  if (vehicle) {
    const {
      vin,
      commissionNumber,
      carPrices,
      cartypeText,
      model,
      dynamicAttributes,
      titleText,
      modelInfo,
      subtitleText,
      colorInfo,
      manufacturerSpecificItems,
      engineInfo,
    } = vehicle;

    // Mapping different data based on Tier
    const msrp =
      carPrices?.find((toCheck) => toCheck.type === 'list')?.price?.valueAsText ||
      carPrices?.find((toCheck) => toCheck.type === 'final')?.price?.valueAsText;
    const dealerPrice =
      carPrices?.find((toCheck) => toCheck.type === 'final')?.price?.valueAsText || '';
    const modelPrice = isTier3 ? dealerPrice : msrp;
    const bodyType = manufacturerSpecificItems?.cdbItems?.find((item) => item?.id === 'body-type')
      ?.value?.length
      ? manufacturerSpecificItems?.cdbItems?.find((item) => item?.id === 'body-type')?.value
      : '';
    const stockNumberTier3 = dynamicAttributes?.find(
      (toCheck) => toCheck.id === 'VEHICLE_ID',
    )?.value;
    const make = titleText?.includes('Audi') ? 'Audi' : titleText;

    return {
      vin,
      stockNumber: isTier3 ? stockNumberTier3 : commissionNumber,
      msrpTotal: modelPrice,
      status: cartypeText === 'N' ? 'NEW' : 'CPO',
      year: model?.salesModelyear,
      make,
      model: modelInfo?.genericModel?.text,
      trim: subtitleText,
      exteriorColor: colorInfo?.exteriorColor?.colorInfo?.text,
      bodyType,
      fuelType: engineInfo?.fuel?.text,
    };
  }
  return undefined;
};
